/**
 * Cipher Block Chaining Sample encryption scheme.
 *
 * @group DRM
 *
 * @beta
 */
export const CBCS = 'cbcs';
